var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5879_6163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8296 13.4979V3.49792H20.1629V13.4979H16.8296ZM13.4963 3.49792C13.9383 3.49792 14.3622 3.67352 14.6748 3.98608C14.9873 4.29864 15.1629 4.72256 15.1629 5.16459V13.4979C15.1629 13.9563 14.9796 14.3729 14.6713 14.6729L9.18792 20.1646L8.30459 19.2813C8.07959 19.0563 7.93792 18.7479 7.93792 18.3979L7.96292 18.1396L8.75459 14.3313H3.49626C2.57126 14.3313 1.82959 13.5813 1.82959 12.6646V10.9979C1.82959 10.7813 1.87126 10.5813 1.94626 10.3896L4.46292 4.51459C4.71292 3.91459 5.30459 3.49792 5.99626 3.49792H13.4963ZM13.4963 5.16459H5.97126L3.49626 10.9979V12.6646H10.8129L9.87126 17.0979L13.4963 13.4729V5.16459Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5879_6163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.996094 0.997925)"
  })))));
};
export default SvgNo;